import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 bg-accent/10" data-id="element-122">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-123">
        <FadeIn data-id="element-124">
          <div className="flex justify-center gap-2 mb-8" data-id="element-125">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-accent fill-accent" data-id="element-126" />)}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-brown-dark mb-8" data-id="element-127">
            Qué cambia en 7 días
          </h2>
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-accent/20" data-id="element-128">
            <p className="text-xl md:text-2xl text-brown-dark leading-relaxed font-serif italic" data-id="element-129">
              "Tu bebé empieza a dormir por periodos más largos, tú recuperas
              horas de sueño y la desesperación nocturna disminuye
              gradualmente."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}